<template>
  <div
    class="
      onlineTest
      d-flex
      flex-column
      justify-content-center
      align-items-center
      pb-5
    "
  >
    <LoaderContent
      v-if="isLoading"
      :welcomeMessage="false"
      :alignSpinnerTop="false"
    />

    <div
      class="bg-white shadow-sm p-4 p-md-5 mt-5 w-100"
      v-for="(question, iq) in questions"
      :key="iq"
    >
      <h5 class="text-secondary">{{ test_name }}</h5>
      <p>Pergunta {{ question.order }} de {{ question.qtd_of_questions }}</p>

      <hr class="mb-4" />

      <b-tabs card no-nav-style nav-wrapper-class="d-none">
        <b-tab class="p-0">
          <h4 class="text-blue-ml font-weight-normal" v-html="question.question"></h4>
          <div
            v-if="question.image != null"
            class="d-flex justify-content-center image-title"
          >
            <img :src="question.image" />
          </div>

          <div v-if="question.is_movie">
            <div class="form-group mt-4">
              <label for="input-video">Entrevista em Video</label>
              <input
                class="form-control form-control-lg"
                type="url"
                v-model="url_movie"
                id="input-video"
              />
              <small id="emailHelp" class="form-text text-muted"
                >Apenas vídeos do YouTube</small
              >
            </div>
          </div>
 
          <div v-else-if="question.is_text">
            <div class="form-group mb-4">
              <label for="text-answer">Preencha sua resposta no campo abaixo.</label>
              <textarea class="form-control form-control-lg" id="text-answer" rows="5" v-model="text_answer" :minlength="question.min_characters" :maxlength="question.max_characters"></textarea>
              <small class="form-text text-muted">{{ text_answer.length }}/{{ question.max_characters }}</small>
            </div>
          </div>

          <div v-else>
            <p>Selecione {{ question.required_answers }} opções</p>

            <div v-for="(option, io) in question.options">
              <b-button
                :key="io"
                class="
                  btn-white
                  border
                  btn-block
                  p-0
                  mb-3
                  text-left
                  d-flex
                  align-items-center
                "
              >
                <div v-if="question.required_answers == 1" >
                  <enhanced-check-radio
                    class="check"
                    :id="`${option.id}`"
                    :value="[[option.id]]"
                    v-model="checkQuestion"
                    :rounded="true"
                    :animate="true"
                    :label="[option.option]"
                  >
                  </enhanced-check-radio>
                </div>
                <div v-else>
                  <enhanced-check
                    class="check"
                    :id="`${option.id}`"
                    :value="option.id"
                    v-model="checkQuestion"
                    :disabled="
                      checkQuestion.length == 3 &&
                      checkQuestion.indexOf(option.id) === -1
                    "
                    :rounded="true"
                    :animate="true"
                    :label="option.option"
                  >
                  </enhanced-check>
                </div>
              </b-button>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <div class="row mt-3" v-for="(question, iq) in questions">
      <div class="col-12 text-center">
        <button
          class="btn btn-light mr-3"
          @click="tabIndex--"
          v-show="tabIndex != 0"
        >
          Voltar
        </button>

        <button
          v-if="question.link[0].next != undefined"
          class="btn btn-lg btn-blue-ml"
          @click="nextTab()"
        >
          <span v-if="!isSaving">Próxima Pergunta</span>
          <EllipsisLoader v-else />
        </button>

        <button
          v-if="question.link[0].next === undefined"
          class="btn btn-lg btn-blue-ml"
          @click="nextTab()"
        >
          <span v-if="!isSaving">Finalizar</span>
          <EllipsisLoader v-else />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "ninenine-white-label/Vue";
import LoaderContent from "@/components/loader/LoaderContent.vue";
import EllipsisLoader from "@/components/loader/EllipsisLoader.vue";
import {
  EnhancedCheck,
  EnhancedCheckGroup,
  EnhancedCheckRadio,
  EnhancedToggle,
} from "vue-enhanced-check";

export default {
  name: "OnlineTests",
  props: {
    headerTestId: String,
  },

  data() {
    return {
      isLoading: false,
      isSaving: false,
      tabIndex: 0,
      checkQuestion: [],
      url_movie: "",
      test_name: "",
      text_answer: "",
      questions: [
        {
          question: "",
          image: "",
          is_movie: false,
          options: [],
          link: [{ prev: "", next: "" }],
          order: "",
          required_answers: "",
          qtd_of_questions: "",
        },
      ],
    };
  },

  head() {
    return this.$head({
      title: "",
    });
  },

  mounted() {
    this.isLoading = true;

    // Valida se já respondeu a questão que está tentando acessar. Se sim, volta para Cover
    let testNavigation = localStorage.getItem("testNavigation");
    if (testNavigation) testNavigation = atob(testNavigation);
    testNavigation = JSON.parse(testNavigation) || {};

    if (
      testNavigation.answered == this.$route.path &&
      testNavigation.can_edit == false
    ) {
      this.$router.push(testNavigation.cover_url);
      return;
    }

    this.$store
      .dispatch("tests/testQuestion", {
        headerTestId: this.$route.params["headerTestId"],
        questionId: this.$route.params["first_question"],
      })
      .then((questions) => {
        const test = questions.testQuestion.json.header_questions;

        this.test_name = test.header.test_name;

        this.questions[0].question = test.question.title;

        this.questions[0].image = test.question.image;

        this.questions[0].is_movie = test.question.is_movie;

        this.questions[0].is_text = test.question.is_text;

        test.question.answer_options.forEach((element, index) => {
          this.questions[0].options[index] = element;
        });

        this.questions[0].link[0].next = test.links.next;

        this.questions[0].link[0].prev = test.links.prev;

        this.questions[0].order = test.question.order;

        this.questions[0].required_answers = test.question.required_answers;

        this.questions[0].qtd_of_questions = test.header.qtd_of_questions;

        this.isLoading = false;
      });
  },

  computed: {
    opportunityId() {
      const id = this.$route.params.id.match(/\d+/)[0];
      return id;
    },
  },

  components: {
    LoaderContent,
    EllipsisLoader,
    EnhancedCheck,
    EnhancedCheckGroup,
    EnhancedCheckRadio,
    EnhancedToggle,
  },

  methods: {
    nextTab() {
      let required_answers = this.$data.questions[0].required_answers;

      if (this.questions[0].is_movie) {
        if (
          /(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)?(?:.*v=|v\/|\/)([\w\-_]+)\&?/.test(
            this.url_movie
          ) == false
        ) {
          this.$swal("Uoops", `Insira apenas vídeo do YouTube`, "error");
        } else {
          this.checkQuestion = this.questions[0].options[0].id;
          this.saveForm();
        }
      } else if (this.questions[0].is_text) {
        if (this.text_answer.length == 0
            || this.text_answer.length < this.questions[0].min_characters
            || this.text_answer.length > this.questions[0].max_characters) {
          this.$swal('Uoops', `Sua resposta deve conter entre ${this.questions[0].min_characters} e ${this.questions[0].max_characters} caracteres`, 'error');
        } else {
          this.checkQuestion = this.questions[0].options[0].id;
          this.saveForm();
        }
      } else {
        if (this.checkQuestion.length != required_answers) {
          this.$swal(
            "Uoops",
            `Selecione ${required_answers} ${
              required_answers == 1 ? "opção" : "opções"
            }`,
            "error"
          );
        } else {
          this.saveForm();
        }
      }
    },

    saveForm() {
      this.isLoading = true;
      this.isSaving = true;

      let next = this.$data.questions[0].link[0].next;

      let headerTest = this.$route.params["headerTestId"];

      let questionId = this.$route.params["first_question"];

      const url = `${Vue.prototype.PLATFORM_TEST}/v1/header/${headerTest}/questions/${questionId}`;

      this.$store
        .dispatch("tests/saveTestQuestion", {
          url: url,
          answers: this.checkQuestion,
          url_movie: this.url_movie,
          text_answer: this.text_answer,
          time_to_finish: 2000,
        })
        .then((response) => {
          this.isLoading = false;
          this.isSaving = false;

          if (response.error) {
            this.$swal(
              "Uoops",
              "Ocorreu um erro ao salvar suas informações",
              "error"
            );
          } else {
            this.$store.commit("tests/SET_TEST_NAVIGATION_CONTROL", {
              answered: this.$route.path,
            });

            if (next != undefined) {
              let nextQuestionId = next.match(/\d+/g, " ")[3];
              this.$router.push({ params: { first_question: nextQuestionId } });
            } else {
              if (window.afterTestBackTo) {
                this.$router.push(window.afterTestBackTo);
                delete window.afterTestBackTo;
              } else {
                this.$router.push(
                  `/vagas/${this.$route.params.id}/inscricao/testes`
                );
              }
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.tabs {
  .btn {
    white-space: normal;
  }
}

/deep/.check {
  width: 100%;
  height: 100%;
  div {
    margin: 0;
  }
  label {
    border: none !important;
    padding: 15px 15px 15px 45px !important;
    width: 100%;
    display: flex !important;
    margin: 0;

    &::before {
      border: 1px solid theme-color("blue-ml");
      background: white !important;
      width: 25px !important;
      height: 25px !important;
      top: 50% !important;
      left: 10px !important;
      bottom: auto !important;
      margin-top: -12px !important;

      &:hover {
        line-height: 160% !important;
      }
    }
  }

  input[type="checkbox"]:not(:checked) + label:hover:before,
  input[type="radio"]:not(:checked) + label:hover:before {
    line-height: 170% !important;
    color: theme-color("blue-ml") !important ;
    content: "";
  }

  input[type="radio"],
  input[type="checkbox"] {
    &:checked + label {
      &:before {
        background: theme-color("blue-ml") !important ;
        color: white;
        line-height: 170% !important;
      }
    }
  }
}

.onlineTest {
  min-height: 100vh;

  .image-title {
    img {
      min-width: 250px;
      max-width: 250px;
      height: auto;
    }
  }
}
</style>